<mat-spinner *ngIf="!loaded" diameter="50"></mat-spinner>

<div *ngIf="loaded" class="save-header">
  <h2>Client focus</h2>

  <div>
    <iris-button
      (click)="onCancel()"
      [disabled]="saving"
      [buttonType]="IrisButtonTypes.SECONDARY"
      aria-label="Cancel"
      data-test="cancel-client-focus-changes"
    >
      Cancel
    </iris-button>
    <iris-button
      (click)="onSave()"
      [disabled]="saving"
      aria-label="Save"
      data-test="save-client-focus-changes"
    >
      Save
    </iris-button>
  </div>
</div>

<iris-card *ngIf="loaded" class="profile-focus-card">
  <h3 class="iris-h3-responsive" data-test="title-focus">Populations and modalities</h3>
  <div class="iris-body-responsive">All fields are required unless marked optional. Your responses will be used to
    match clients to providers who best fit their needs.
  </div>
  <div class="ages-and-services-container">
    <section>
      <h4 [ngClass]="{ 'error error-h4' : !servicesFormChecked }" data-test="services-offered">Which services do you provide?</h4>
      <span class="error" *ngIf="!servicesFormChecked">This is a required question. You must select a response.</span>
      <sondermind-reference-datum-checklist
        [form]="modalitiesForm"
        [refDatumItems]="modalities$ | async"
        data-test="services-offered-checkbox"
      ></sondermind-reference-datum-checklist>
    </section>

    <section class="languages-section">
      <h4 [ngClass]="{ 'error error-h4' : !languageFormChecked }" data-test="subtitle-languages">Which languages do you conduct therapy in?</h4>
      <span class="error" *ngIf="!languageFormChecked">This is a required question. You must select a response.</span>
      <sondermind-reference-datum-checklist
        [form]="languageForm"
        [refDatumItems]="languages"
        data-test="languages-checkbox"
      ></sondermind-reference-datum-checklist>
    </section>

    <section>
      <h4 data-test="population-groups">
        Which age ranges do you prefer to treat?
        <small class="iris-legal-responsive optional-text">Optional</small>
      </h4>
      <div class="iris-body-responsive helper-text">Depending on the matches we have in the areas where you are licensed, we may occasionally
        send you matches who are outside your age preference. If you have no preference, check all.
      </div>
      <sondermind-reference-datum-checklist
        [form]="agesForm"
        [refDatumItems]="ages"
      ></sondermind-reference-datum-checklist>
    </section>
  </div>

  <h3 class="iris-h3-responsive" data-test="title-client-identities">Client identities</h3>
  <p class="iris-body-responsive visibility-msg">
    <mat-icon
      [inline]="true"
    >
      visibility_off
    </mat-icon>
    Not visible to clients on your SonderMind Profile
  </p>
  <div class="iris-body-responsive">Your responses will be used internally to match clients to the providers who best fit their needs.</div>
  
  <h4 data-test="sexualities">
    Which sexual orientations do you specialize in discussing with clients, if any?
    <small class="iris-legal-responsive optional-text">Optional</small>
  </h4>
  
  <sondermind-reference-datum-checklist
    [form]="sexualitiesForm"
    [refDatumItems]="sexualities$ | async"
  ></sondermind-reference-datum-checklist>

  <h4 data-test="religions">
    Which religious identities do you specialize in discussing with clients, if any?
    <small class="iris-legal-responsive optional-text">Optional</small>
  </h4>
  
  <sondermind-reference-datum-checklist
    [form]="religionsForm"
    [refDatumItems]="religions$ | async"
  ></sondermind-reference-datum-checklist>
</iris-card>
